import React from 'react';
import PrivacyPolicy from './privacy-policy';
import { ILinks } from '../ICommon';
import { ISubLinksProps } from '../../IFooter';
import { useTranslator } from '../../../header/locales-provider';

const SubFooter = ({ items }: ISubLinksProps): JSX.Element => {
  const { links, copyright } = items || {};
  const locales = useTranslator('global');
  return (
    <div>
      <div className="py-4 container flex flex-row items-center mx-auto text-sm xl:text-base text-white">
        <span className="flex">
          <a className="underline" href="javascript:(OneTrust.ToggleInfoDisplay())" target="_self"> {locales?.['footer.link.privacyChoices']}</a>
          <span className="px-2"> | </span>
        </span>

        {links?.map((link: ILinks, index: number) => {
          if (index === 0) {
            return (
              <span className="flex" key={`ft-pp-${index}`}>
                <PrivacyPolicy items={link} />
                <span className="px-2"> | </span>
              </span>
            );
          }
          return <PrivacyPolicy items={link} key={`ft-pp-${index}`} />;
        })}
      </div>
      <div className="py-4 text-sm xl:text-base text-white">{copyright}</div>
    </div>
  );
};

export default SubFooter;
